<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-5xl">
        <a routerLink="/products/hardware" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back to Hardware
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">Varroc Connect <span class="text-varroc-accent">OBD Dongle</span></h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-4xl" data-aos="fade-up" data-aos-delay="200">The Varroc Connect OBD Dongle is a compact, plug & play hardware device designed to instantly enable vehicle connectivity. Built for ease of installation and reliable performance, the device connects directly to the vehicle’s OBD port without any wiring or technical intervention.</p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/store/product" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all varroc_connect_obd_dongle_shop_now_button">Shop Now</a>
          <a routerLink="/contact-us" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all varroc_connect_obd_dongle_request_sample_button">Request Sample</a>
        </div>
      </div>
    </div>
  </section>
  <nav class="sticky-product-nav"><div class="max-w-7xl mx-auto px-6"><div class="flex overflow-x-auto">
    <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0"><i class='bx text-base' [class]="s.icon"></i> {{ s.label }}</a>
  </div></div></nav>
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="grid lg:grid-cols-[1.1fr,0.9fr] gap-10 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
          <h2 class="text-4xl font-black mt-2 mb-4">Plug & Play Hardware Device for Instant Vehicle Connectivity</h2>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-5">The Varroc Connect OBD Dongle is built for immediate activation, reliable telemetry, and easy scale across OEM, fleet, BFSI, consumer, and logistics programs.</p>
          <p class="text-varroc-text-gray leading-relaxed">Its compact hardware design, integrated connectivity, and broad vehicle compatibility make it a practical entry point for connected mobility use cases without wiring-heavy deployments.</p>
        </div>
        <div class="grid sm:grid-cols-3 gap-5" data-aos="fade-left">
          <div *ngFor="let item of overviewHighlights" class="feature-card text-center">
            <div class="text-varroc-accent font-black text-2xl mb-2">{{ item.val }}</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="features" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Hardware Features</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Core Device Capabilities</h2>
        <p class="text-varroc-text-gray max-w-3xl mx-auto">Purpose-built hardware, embedded connectivity, and secure transmission features designed for practical connected vehicle deployments.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div *ngFor="let feature of hardwareFeatures; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="feature.icon"></i>
          </div>
          <div class="text-white font-bold mb-2">{{ feature.title }}</div>
          <div class="text-varroc-text-gray text-sm leading-relaxed">{{ feature.value }}</div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="variants" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Product Variants</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Deployment Options</h2>
        <p class="text-varroc-text-gray max-w-3xl mx-auto">Choose the OBD configuration based on connectivity requirements, data depth, and vehicle compatibility across deployments.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-5">
        <div *ngFor="let variant of variants; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="flex items-center justify-between mb-4">
            <span class="bg-varroc-accent/20 text-varroc-accent text-xs font-bold px-3 py-1 rounded-full">{{ variant.tag }}</span>
          </div>
          <div class="text-white font-bold mb-2">{{ variant.title }}</div>
          <div class="text-varroc-text-gray text-sm leading-relaxed">{{ variant.value }}</div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="applications" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Applications</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Where the OBD Dongle Fits</h2>
        <p class="text-varroc-text-gray max-w-3xl mx-auto">The device fits multiple connected mobility programs, from OEM integration and enterprise operations to end-consumer tracking use cases.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div *ngFor="let application of applications; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="application.icon"></i>
          </div>
          <div class="text-white font-bold mb-2">{{ application.title }}</div>
          <div class="text-varroc-text-gray text-sm leading-relaxed">{{ application.desc }}</div>
        </div>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="how-it-works" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">How It Works</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Simple Connected Flow</h2>
        <p class="text-varroc-text-gray max-w-3xl mx-auto">A clear four-step device flow from plug-in to platform data visibility.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-5">
        <div *ngFor="let step of howItWorks; let i = index" class="feature-card flex items-start gap-4" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-10 h-10 rounded-full bg-varroc-accent/15 text-varroc-accent font-black flex items-center justify-center flex-shrink-0">{{ i + 1 }}</div>
          <div class="pt-1">
            <div class="text-white font-semibold text-sm mb-1">{{ step.title }}</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">{{ step.desc }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
